import { AvField, AvForm } from "availity-reactstrap-validation"
import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router"
import { CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"

//actions
import {
  createLeadNotes,
  getLeads,
  getMembers,
  updateLeadNotes,
} from "store/actions"
import PropTypes from "prop-types"

const CreateForm = ({ show, onCloseClick, updateData }) => {
  const dispatch = useDispatch()
  const params = useParams()

  useEffect(() => {
    dispatch(getMembers("", "", "", "", ""))
  }, [dispatch])

  useEffect(() => {
    dispatch(getLeads("", "", "", "", "", "", ""))
  }, [dispatch])

  const leadnotesId = updateData?._id

  function handleValidSubmit(e, v) {
    if (updateData?._id) {
      const updateData = {
        ...v,
        lead: params?.id,
      }
      dispatch(updateLeadNotes(updateData, leadnotesId, onCloseClick))
    } else {
      const createData = {
        ...v,
        lead: params?.id,
      }
      dispatch(createLeadNotes(createData, onCloseClick))
    }
  }

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id ? "Edit Lead-Notes" : "Add Lead-Notes"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <>
              <Col className="col-12 py-2">
                <label>Note</label>
                <AvField
                  name="note"
                  type="textarea"
                  value={updateData?.note ?? ""}
                  validate={{
                    required: {
                      value: false,
                      errorMessage: "name is required",
                    },
                  }}
                />
              </Col>
            </>
          </Row>

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-warning ms-2">
                {updateData?._id ? "Save" : "Create"}
              </button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

export default CreateForm

CreateForm.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
}
